module.exports = '/ng-templates/features/record/kp-documents-carousel/kp-documents-carousel.tpl.ftl';
